module.exports = __webpack_public_path__ + "img/icon_select_red.ced12bed.svg";